var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,23.36L21.533,26.706C22.547,27.32 23.787,26.413 23.52,25.266L22.053,18.973L26.947,14.733C27.84,13.96 27.36,12.493 26.187,12.4L19.747,11.853L17.227,5.906C16.773,4.826 15.227,4.826 14.773,5.906L12.253,11.84L5.813,12.386C4.64,12.48 4.16,13.946 5.053,14.72L9.947,18.96L8.48,25.253C8.213,26.4 9.453,27.306 10.467,26.693L16,23.36Z",
    fill: "#909BF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpgStar);
export default __webpack_public_path__ + "static/media/spgStar.397aaf1b2de98a904345077a49cf7806.svg";
export { ForwardRef as ReactComponent };